<div [ngClass]="{
    'card': true,
    'w-100': true,
    'card-new-style': !isCardInactive() || !(isIndividualCards || isTeamCards),
    'card-new-style-inactive': isCardInactive() && (isIndividualCards || isTeamCards),
    'selected-border': reservedIdentificationId && singleCard.userCardResponse.isReservedCardActive
  }"
     (click)="!isCardInactive() && navigateToUserSinglePage(singleCard.userCardResponse.cardId)">
  @if (isDeleteButtonFromHistoryActive) {
    <div class="card-close-button" (click)="onDeleteFromHistory(singleCard.id, $event)">
      <button class="close-icon-button">
        <img src="assets/svg/close-icon.svg">
      </button>
    </div>
  }
  @if (reservedIdentificationId) {
    <div class="card-close-button" (click)="toggle(singleCard.userCardResponse.id, reservedIdentificationId, $event)">
      @if (singleCard.userCardResponse.active) {
        <label
          class="close-icon-button">
          <img
            [src]="singleCard.userCardResponse.isReservedCardActive
        ? 'assets/svg/checked-icon.svg'
        : 'assets/svg/unselected-icon.svg'"
            alt="Toggle"
          />
        </label>
      }
    </div>
  } @else if (isDeleteButtonFromTeamActive && !singleCard.userCardResponse.subscriptionExpired && !reservedIdentificationId) {
    <div class="card-close-button" (click)="onDeleteFromTeam($event)">
      <button class="close-icon-button">
        <img src="assets/svg/close-icon.svg">
      </button>
    </div>
  }
  @if (team && !isCardInactive() && !reservedIdentificationId) {
    <div class="copy-close-button" (click)="$event.stopPropagation(); openEditDialogForMemberAdd()">
      <button class="copy-icon-button">
        <img class="cursor-pointer" src="assets/svg/copy.svg" alt="Copy code">
      </button>
    </div>
  }
  @if (isDeleteButtonFromIndividualsActive && singleCard.userCardResponse.editable && !singleCard.userCardResponse.subscriptionExpired && !reservedIdentificationId) {
    <div class="card-close-button" (click)="onDeleteFromIndividuals(singleCard.userCardResponse.id, $event)">
      <button class="close-icon-button">
        <img src="assets/svg/close-icon.svg">
      </button>
    </div>
  }
  <div class="card-new-cover-image-div">
    <div class="cover-image-overlay">
      @if (isStarActive) {
        <svg
          [ngClass]="{'star-click': isFavoriteMap[singleCard.userCardResponse.id],'star-click-clicked': !isFavoriteMap[singleCard.userCardResponse.id]}"
          (click)="onStar(singleCard.userCardResponse.id, $event)"
          width="24" height="24" viewBox="0 0 45 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M30.681 40.8131L30.7405 40.8298L30.8017 40.8389C31.1365 40.8892 31.3999 40.9274 31.5899 40.9533L31.5961 40.9542C31.7395 40.9737 31.9321 41 32.05 41C33.3992 41 34.5822 40.482 35.5571 39.5071C36.558 38.5062 37.04 37.2546 36.9997 35.8236C36.9996 35.8229 36.9996 35.8222 36.9996 35.8214L36.8078 27.9561L42.1133 20.4319C42.4395 19.982 42.684 19.4976 42.835 18.98C42.9771 18.4928 43.05 17.9986 43.05 17.5C43.05 16.4269 42.7362 15.4358 42.1201 14.5528C41.4899 13.6494 40.6221 13.0287 39.5566 12.6981L31.3558 9.9484L25.9456 2.9441C25.4563 2.2936 24.8547 1.79006 24.1388 1.46463C23.4598 1.15599 22.7438 1 22 1C21.2562 1 20.5402 1.15599 19.8612 1.46463C19.1453 1.79006 18.5437 2.2936 18.0544 2.9441L12.6442 9.9484L4.4321 12.7019L4.43208 12.7018L4.42289 12.705C3.36484 13.0713 2.50802 13.7083 1.89593 14.6159C1.30559 15.4912 1 16.4597 1 17.5C1 17.9986 1.07291 18.4928 1.215 18.98C1.36592 19.4974 1.61031 19.9816 1.93635 20.4314L7.1923 27.9055L7.00041 35.8214C7.00039 35.8222 7.00037 35.8229 7.00035 35.8236C6.95999 37.2546 7.44203 38.5062 8.44289 39.5071C9.4178 40.482 10.6008 41 11.95 41C12.1493 41 12.3608 40.9901 12.583 40.9715C12.8505 40.9493 13.1131 40.8945 13.365 40.8003L22 38.3883L30.681 40.8131Z"
            fill="#FACE55" stroke="white" stroke-width="2"/>
        </svg>
      }
      @if (singleCard?.userCardResponse?.subscription?.subscriptionInfoResponse?.isAdditional) {
        <span class="image-label">{{ 'user_card.additional' | translate }}</span>
      }
    </div>
    <img class="w-100 cover-image-content"
         [src]="singleCard.userCardResponse.coverImage ? getUserCardImage(singleCard.userCardResponse.id, ImageType.COVER_IMAGE) : 'assets/images/defBackgroundImage.png'"
         alt="Cover image">
  </div>
  <div class="d-flex justify-content-between">
    <div class="d-flex justify-content-left"></div>
    <div class="d-flex justify-content-center">
      <div [ngClass]="singleCard.userCardResponse.profilePic ? 'profile-pic-div' : 'profile-empty-pic-div'"
           class="profile-pic-div-for-change">
        <label for="forImage" class="pointer-custom col-sm-12">
          <div id="forImage" class="col-sm-12 text-center image-div">
            <img
              [src]="singleCard.userCardResponse.profilePic ? getUserCardImage(singleCard.userCardResponse.id, ImageType.PROFILE_PIC) : 'assets/svg/defaultUserIcon.svg'"
              class="image-style" alt="">
            @if (companyLogoExists) {
              <img [src]="getUserCardImage(singleCard.userCardResponse.id,ImageType.COMPANY_LOGO)"
                   class="company-image-style" alt="">
            }
          </div>
        </label>
      </div>
    </div>
    <div class="d-flex justify-content-end"></div>
  </div>
  <div class="pb-30 changed-new">
    <div
      [ngClass]="isCardInactive() && (isIndividualCards || isTeamCards) ? 'user-card-id-container-inactive d-flex justify-content-center' : 'user-card-id-container d-flex justify-content-center'">
      <span class="user-card-id-text">{{ singleCard.userCardResponse.cardId }}</span>
    </div>
    <div class="user-information-container">
      <div class="user-card-name-surname">
        <span>
          {{
            (singleCard.userCardResponse.name + ' ' + singleCard.userCardResponse.surname)
              | slice:0:25
          }}{{ (singleCard.userCardResponse.name + ' ' + singleCard.userCardResponse.surname).length > 25 ? '…' : '' }}
          @if (singleCard.userCardResponse.isBusiness) {
            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
             <circle cx="10" cy="10.2539" r="10" fill="#12314F"/>
              <mask id="mask0_1677_3798" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="4" y="4" width="12"
                    height="13">
                <rect x="4" y="4.08594" width="12" height="12" fill="#D9D9D9"/>
              </mask>
             <g mask="url(#mask0_1677_3798)">
               <path
                 d="M5.99805 14.5859C5.72305 14.5859 5.48763 14.488 5.2918 14.2922C5.09596 14.0964 4.99805 13.8609 4.99805 13.5859V11.5859H8.49805V12.5859H11.498V11.5859H14.998V13.5859C14.998 13.8609 14.9001 14.0964 14.7043 14.2922C14.5085 14.488 14.273 14.5859 13.998 14.5859H5.99805ZM9.49805 11.5859V10.5859H10.498V11.5859H9.49805ZM4.99805 10.5859V8.08594C4.99805 7.81094 5.09596 7.57552 5.2918 7.37969C5.48763 7.18385 5.72305 7.08594 5.99805 7.08594H7.99805V6.08594C7.99805 5.81094 8.09596 5.57552 8.2918 5.37969C8.48763 5.18385 8.72305 5.08594 8.99805 5.08594H10.998C11.273 5.08594 11.5085 5.18385 11.7043 5.37969C11.9001 5.57552 11.998 5.81094 11.998 6.08594V7.08594H13.998C14.273 7.08594 14.5085 7.18385 14.7043 7.37969C14.9001 7.57552 14.998 7.81094 14.998 8.08594V10.5859H11.498V9.58594H8.49805V10.5859H4.99805ZM8.99805 7.08594H10.998V6.08594H8.99805V7.08594Z"
                 fill="white"/>
             </g>
            </svg>
          }
        </span>
      </div>
      <div class="user-card-specialization-text">
        @if (singleCard.userCardResponse.specialization) {
          <span>{{ truncateText(singleCard.userCardResponse.specialization, 25) }}</span>
        }
        @if (singleCard.userCardResponse.specialization && singleCard.userCardResponse.company) {
          {{ ' • ' }}
        }
        @if (singleCard.userCardResponse.company) {
          <span>{{ truncateText(singleCard.userCardResponse.company, 25) }}</span>
        }
      </div>
      <div class="form-group default-height margin-top-custom-loc">
        <span class="mb-0 specialization-p">{{ singleCard.userCardResponse.location }}</span>
      </div>
    </div>
    <div class="mt-2 edit-delete-buttons">
      <div class="top-buttons">
        <button
          [ngClass]="isCardInactive() && (isIndividualCards || isTeamCards) ? 'filled-inactive-button short-button width-100' : 'filled-button short-button width-100'"
          [disabled]="isCardInactive()"
          (click)="showQRCode(singleCard.userCardResponse.id, $event)">
          <span class="button-content">
            <mat-icon class="mr-10px">qr_code</mat-icon>
            {{ 'individual_card.show_qr' | translate }}
          </span>
        </button>
      </div>
      @if (showEditSection && !reservedIdentificationId) {
        <div class="bottom-buttons">
          <div class="central-pos">
            <button
              [ngClass]="isCardInactive() && (isIndividualCards || isTeamCards) ? 'bb-style-inactive' : 'bb-style'"
              [disabled]="isCardInactive()" (click)="navigateToeDitPage(singleCard.userCardResponse.id)">{{ 'individual_card.edit' | translate }}
            </button>
            @if (!isIndividualCards && !singleCard.userCardResponse.subscriptionExpired) {
              <div class="switch switch-change" [class.active]="isCardActive" (click)="toggleSwitch($event)">
                <div class="slider"></div>
              </div>
            } @else {
              @if (!singleCard.userCardResponse.subscriptionExpired) {
                <div class="switch switch-change" [class.active]="isCardActive"
                     (click)="toggleSwitchActiveOrInActiveCard(singleCard.userCardResponse.id, $event)">
                  <div class="slider"></div>
                </div>
              }
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
